import { FETCH_ADVERTISEMENTS_FAILURE,
  FETCH_ADVERTISEMENTS_REQUESTED,
  FETCH_ADVERTISEMENTS_SUCCESS } from "../actions/ads-action-types";

const initialState = {
  ads: [],
  fetchAdsStatus: "pending",
};

export default function locations(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case FETCH_ADVERTISEMENTS_FAILURE:
      return {
        ...state,
        fetchAdsStatus: "failure",
      };

    case FETCH_ADVERTISEMENTS_REQUESTED:
      return {
        ...state,
        fetchAdsStatus: "fetching",
      };

    case FETCH_ADVERTISEMENTS_SUCCESS:
      return {
        ...state,
        ads: payload,
        fetchAdsStatus: "success",
      };

    default:
      return state;
  }
}
